













import gbutton from "./button.vue"
import tooltip from "./tooltip.vue"
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { frontendClient } from "../lib/client";

export interface UserItem{
    ID:string,
    name?:string,
    phoneNumber?:string,
    rank?:string,
    email?:string,
}

@Component({
    components : {
        gbutton,
        tooltip
    },
})
export default class UserRow extends Vue{

    @Prop({}) dev:boolean;
    @Prop({}) row:boolean;
    @Prop({}) user:UserItem;
    @Prop({}) noOpen:boolean;
    @Prop({}) message:string;

    // TODO: REMOVE FOR PRODUCTION
    phone:string = this.user.phoneNumber || null;
    image: string = null;
    initial: string=null;
    colors: string[] = ["#1DE9B6","#00E676","#64FFDA","#2979FF","#2962FF"];
    color: string = null;

    openUserDetail(route,parameters?){
        this.$router.replace({ name: 'userDetails', params: {id: this.user.ID}});
    };

    openCall(){
        if(this.noOpen) return;
        if(this.phone != null){
            window.open(`tel:${this.phone}`)
        }
    }

    mounted(){
        if(!this.user.phoneNumber || this.user.phoneNumber == undefined || this.phone == null){
            this.phone = null;
        }

        this.getImg();
        this.getUserChar();
    }

    getImg(){
        if(frontendClient.userData.displayImageURL != null) this.image = frontendClient.userData.displayImageURL;
        else{
            let index = Math.round(Math.random() * this.colors.length);
            this.color = this.colors[index];
        }
    }

    getUserChar(){
        this.initial = (this.user.name).charAt(0);
    }
}
